const ROW_REGEX = /<tr>(.*?)<\/tr>/gs;
const DATA_REGEX = /<td.*?>(.*?)<\/td>/gs;
const P_REGEX = /<p.*?>(.*?)<\/p>/s;

const getInnerData = (str = []) => {
    const span = document.createElement("div");
    span.innerHTML = str && str[0];
    return span.textContent;
  };

export const getAnnounce = (str = "") => {
    const row = str.match(ROW_REGEX);
    const obj = {};
    const innerRow = row[1].match(DATA_REGEX);
    obj.title = getInnerData(innerRow[0]?.match(P_REGEX));
    obj.desc = getInnerData(innerRow[1]?.match(P_REGEX));
    obj.link = getInnerData(innerRow[2]?.match(P_REGEX));
    obj.buttonText = getInnerData(innerRow[3]?.match(P_REGEX));
    obj.urgent = getInnerData(innerRow[4]?.match(P_REGEX));
    return obj;
};
